import { render, staticRenderFns } from "./SelfServiceFiles/SelfService.html?vue&type=template&id=990cdfc0&scoped=true&external"
import script from "./SelfServiceFiles/SelfService.js?vue&type=script&lang=js&external"
export * from "./SelfServiceFiles/SelfService.js?vue&type=script&lang=js&external"
import style0 from "./SelfServiceFiles/SelfService.scss?vue&type=style&index=0&id=990cdfc0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990cdfc0",
  null
  
)

export default component.exports